export default __webpack_public_path__ + "static/media/unknown.35e513b5.png";